import ActionTypes from "./types";
import announcementAPIHelper from "../../helpers/api/announcementAPIHelper";
import carparkAPIHelper from "../../helpers/api/carparkAPIHelper";

/**
 * Get list for Announcements
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function getList(token, successCallback = null, failCallback = null) {
  return (dispatch) => {
    announcementAPIHelper.getList(
      token,
      (response) => {
        const {
          responseDetail: { data },
        } = response;
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_GET_LIST,
          data: data.map((news) => {
            let { status } = news;
            if (news.status === "hide") status = "draft";
            return { ...news, status };
          }),
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Select the announcement for form input
 * @param {Object} data The data of selected announcement
 * @returns {{data: *, type: string}} Redux Action
 */
export function select(data) {
  return {
    type: ActionTypes.ANNOUNCEMENT_SELECT,
    data,
  };
}

/**
 * Create new announcement
 * @param {Object} data Data for creating a announcement
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function create(data, token, successCallback, failCallback) {
  return (dispatch) => {
    announcementAPIHelper.create(
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_SELECT,
          data: null, // Reset selected announcement
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

/**
 * Update existing announcement
 * @param {String} id ID of the announcement to be updated
 * @param {Object} data Data for updating a announcement
 * @param {String} [token] Token for API calling
 * @param {Function} [successCallback=null] (Optional) Callback function after successful API call
 * @param {Function} [failCallback=null] (Optional) Callback function after failed API call
 * @returns {function(...[*]=)} Dispatch function of Redux action
 */
export function update(id, data, token, successCallback, failCallback) {
  return (dispatch) => {
    announcementAPIHelper.update(
      id,
      data,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_SELECT,
          data: null, // Reset selected announcement
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

export function remove(id, token, successCallback, failCallback) {
  return (dispatch) => {
    announcementAPIHelper.remove(
      id,
      token,
      (response) => {
        const { responseCode } = response;
        if (responseCode !== 200) {
          if (typeof failCallback === "function") failCallback(response);
          return;
        }
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_SELECT,
          data: null, // Reset selected announcement
        });
        if (typeof successCallback === "function") successCallback(response);
      },
      (error) => {
        dispatch({
          type: ActionTypes.ANNOUNCEMENT_SELECT,
          data: null, // Reset selected announcement
        });
        if (typeof failCallback === "function") failCallback(error);
      }
    );
  };
}

const AnnouncementActions = { getList, select, create, update, remove };
export default AnnouncementActions;
